import { createApi, fetchBaseQuery } from "@reduxjs/toolkit/query/react";
import { customFetchBase } from "../customFetchBase";

export const employeesApi = createApi({
  reducerPath: "employeesApi",
  baseQuery: customFetchBase({ url: "pa/employees" }),
  endpoints: (builder) => ({
    getEmployees: builder.query({
      query: ({ page = 1, search, code } = {}) => {
        let url = `?no_of_docs_each_page=25&page=${page}`;
        if (search) url += `&search=${search}`;
        if (code) url += `&code=${code}`;
        return {
          url,
          method: "GET",
        };
      },
    }),
    createEmployee: builder.mutation({
      query: (data) => ({
        method: "POST",
        body: data,
      }),
    }),
    updateEmployee: builder.mutation({
      query: (data) => ({
        method: "PUT",
        body: data,
      }),
    }),
    deleteEmployee: builder.mutation({
      query: (code) => ({
        url: `?code=${code}`,
        method: "DELETE",
      }),
    }),
  }),
});
export const {
  useCreateEmployeeMutation,
  useUpdateEmployeeMutation,
  useGetEmployeesQuery,
  useDeleteEmployeeMutation,
} = employeesApi;
